module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('v-layout', [_c('v-flex', [_c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "solo": "",
      "light": "",
      "placeholder": "Search",
      "autofocus": ""
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      }
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "grey--text ml-0 mr-0 mt-2",
    attrs: {
      "light": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.submit($event)
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dbde4a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheHeader/TheHeaderSearchLarge.vue
// module id = 371
// module chunks = 0